// extracted by mini-css-extract-plugin
module.exports =  {"dropdownShell":"DropdownShell-module__dropdownShell___ejdlk","animatedZone":"DropdownShell-module__animatedZone___yBnQQ"};